// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';
import { Backend } from '@/_axios';

export const LOAD_AUDIT_LOGS = 'LOAD_AUDIT_LOGS';
export const SET_AUDIT_LOGS = 'SET_AUDIT_LOGS';

const state = {
  auditLogs: {}
};

const getters = {
  auditLogs: (state) => {
    return state.auditLogs;
  },
};

const actions = {
  [LOAD_AUDIT_LOGS]: function ({ commit }) {
    Backend.get('/api/audit-logs').then((response) => {
      const auditLogs = {};
      response.data.forEach((auditLog) => {
        auditLogs[auditLog.id] = auditLog;
      });
      commit('SET_AUDIT_LOGS', { auditLogs: auditLogs });
    });
  }
};

const mutations = {
  [SET_AUDIT_LOGS]: function (state, { auditLogs }) {
    state.auditLogs = auditLogs;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
